import { tCaseComponentsLib } from '@/Interfaces/caseComponentsLib';

export const shields: tCaseComponentsLib = [
    {
        id: 'tcs_50x43',
        xmlId: '6c08d50b-c841-266e-26ad-6933e8931db0',
        name: 'TC экран перфорированный TCS 50x43',
        type: 'shield',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'perfo_screen_tcs_50x43',
        image: 'dist/src/img/tcs_50x43.png',
    },
    {
        id: 'lat_scrn_ms',
        xmlId: '094e749f-bd33-65b4-9ad9-bb22bb27cfc3',
        name: 'Комплект боковых экранов Garage MS',
        type: 'shield',
        caseModels: [ 'TC-1947' ],
        blenderName: 'lateral_screen_ms',
        image: 'dist/src/img/lat_scrn_ms.png',
    },
    {
        id: 'niches_tc_1995',
        xmlId: '10a6c47a-6f28-a7f0-0ede-d37aaa2e2c8f',
        name: 'Комплект ниш TC 1995',
        type: 'shield',
        caseModels: [ 'TC-1995' ],
        blenderName: 'set_niches_tc_1995',
        image: 'dist/src/img/niches_tc_1995.png',
    },
    {
        id: 'shi_amh_tc',
        xmlId: '68b116b0-3daf-0cf1-1f0b-6754b529f099',
        name: 'Комплект экранов перфорированных AMH TC (2 шт)',
        type: 'shield',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'perfo_screen_amh_tc',
        image: 'dist/src/img/shi_amh_tc.png',
    },
    {
        id: 'screen_hard',
        xmlId: '8f1214c2-e7a6-2ca3-b14a-e4b0169fbcdb',
        name: 'Экран к шкафу HARD (перф.)',
        type: 'shield',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'perfo_screen_hard',
        image: 'dist/src/img/screen_hard.png',
    },
];
